// extracted by mini-css-extract-plugin
export default {"dialog-layout":"dialog-layout_dialog-layout__iXdAi","show":"dialog-layout_show__vqvtd","content":"dialog-layout_content__4DVG2","close":"dialog-layout_close__bWWfB"};